import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { VersionControlService } from '../version-control.service';

@Component({
  selector: 'app-version-popup',
  templateUrl: './version-popup.component.html',
  styleUrls: ['./version-popup.component.scss'],
  standalone: false
})
export class VersionPopupComponent implements OnInit,OnDestroy {
  @ViewChild('updateBtn') updateBtn: ElementRef;
  showPopup = false;

  secondsRemaining = 10; 
  private autoReloadTimer: any;

  constructor(private versionService: VersionControlService) { }

  ngOnInit(): void {
    this.versionService.showVersionPopup$.subscribe(isVisible => {
      this.showPopup = isVisible;
      
      if (isVisible) {
        // Wait 1 tick for the HTML to render, then force focus
        setTimeout(() => {
          this.setFocus();
        }, 100);

        this.startAutoReload();
      }
    });
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  startAutoReload() {
    this.clearTimer();
    this.secondsRemaining = 10;

    
    this.autoReloadTimer = setInterval(() => {
      this.secondsRemaining--;

      if (this.secondsRemaining <= 0) {
        this.forceReload();
      }
    }, 1000);
  }

  clearTimer() {
    if (this.autoReloadTimer) {
      clearInterval(this.autoReloadTimer);
      this.autoReloadTimer = null;
    }
  }

  setFocus() {
    if (this.updateBtn) {
      this.updateBtn.nativeElement.focus();
    }
  }

  forceReload() {
   this.clearTimer();
   
   const currentUrl = new URL(window.location.href);
    
   // Generates a random param to force the browser to fetch version from the server
    currentUrl.searchParams.set('_v', new Date().getTime().toString());
    
    window.location.href = currentUrl.toString();    
    // Hard reload from server
    //window.location.reload();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.showPopup) {
      if (event.key === 'Tab') {
        event.preventDefault();
        this.setFocus();
      }
    }
  }

}
